<ion-content
	*ngIf="toBeRemovedItems?.length || removedItems?.length; else empty"
	mode="md"
>
	<ion-list *ngIf="toBeRemovedItems?.length" mode="md">
		<ion-list-header color="danger" lines="full" mode="md">
			<ion-label mode="md">
				To Be Removed
			</ion-label>
		</ion-list-header>
		<ion-item-group *ngFor="let item of toBeRemovedItems; index as index">
			<app-inventory-item
				[item]="item"
				[index]="index"
				[isExpanded]="isVisible(index, expandedToBeRemovedItems)"
				(toggledSection)="
					onClickToggleSection($event, expandedToBeRemovedItems)
				"
			></app-inventory-item>
		</ion-item-group>
	</ion-list>
	<ion-list *ngIf="removedItems?.length">
		<ion-list-header color="primary" lines="full" mode="md">
			<ion-label mode="md">
				Removed
			</ion-label>
		</ion-list-header>
		<ion-item-group
			*ngFor="let item of removedItems; index as index"
			mode="md"
		>
			<app-inventory-item
				[item]="item"
				[index]="index"
				[isExpanded]="isVisible(index, expandedRemovedItems)"
				(toggledSection)="
					onClickToggleSection($event, expandedRemovedItems)
				"
			></app-inventory-item>
		</ion-item-group>
	</ion-list>
</ion-content>

<ng-template #empty>
	<app-empty-list-item
		message="No removed inventory on this appointment"
	></app-empty-list-item>
</ng-template>
